export const imageKitThumb = {
  carPageDesktop: 'car_page_desktop',
  carPageMobile: 'car_page_mobile',
  carCard: 'car_card',
  carRecommendationCard: 'car_recommendation_card',
  blogCard: 'blog_card',
  blogPage: 'blog_page',
};
